// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"67747f55","703":"1dfb069c"}[chunkId] + ".chunk.js";
};